import { UseFormSetError } from "react-hook-form";
import { IndividualEmployeeResponseService } from "../../../services/Company/Employee.type";
import { isAddressDangerous, ZonePolygon } from "../../../utils/map";
import { AbsencesFormData } from "../../Absences/Types/Absences.type";
import { GetOneAbsenceResponseService } from "../../../services/Absences/Absences.type";

// INFO: Validate Function for REQUEST and EDIT absence
export const validateAddress = async (
  data: AbsencesFormData,
  zones: ZonePolygon[],
  setError: UseFormSetError<AbsencesFormData>,
  supplementaryReference: string,
  employee?:
    | IndividualEmployeeResponseService
    | GetOneAbsenceResponseService["employee"]
    | null
): Promise<
  | { isValid: false }
  | {
    isValid: true;
    isDangerous: boolean;
    shouldOpenDangerousAlert: boolean;
    coordinates: { latitude: number; longitude: number };
    fullAddress: string;
  }
> => {

  const isEmployeeOutsideHome = data.address || data.city || data.province;

  const fullAddress = isEmployeeOutsideHome
    ? `${data.address}, ${data.city}, ${data.province}`
    : employee
      ? `${employee.fullAddress}(${supplementaryReference}), ${employee.city}, ${employee.province}`
      : null;

  if (!fullAddress) {
    setError("employee", {
      type: "required_employee",
      message: "Seleccionar opción válida*",
    });

    return { isValid: false };
  }

  const { isDangerous, error, message, location } = await isAddressDangerous(
    fullAddress,
    zones,
  );

  if (error || !location) {
    if (isEmployeeOutsideHome) {
      setError("address", {
        type: "invalid_address",
        message: "",
      });
      setError("city", {
        type: "invalid_address",
        message: "",
      });
      setError("province", {
        type: "invalid_address",
        message,
      });
    } else
      setError("employee", {
        type: "invalid_address",
        message,
      });

    return { isValid: false };
  }

  const shouldOpenDangerousAlert =
    isDangerous && data.type === "Visita a Domicilio";

  return {
    isValid: true,
    isDangerous,
    shouldOpenDangerousAlert,
    coordinates: { latitude: location.lat, longitude: location.lng },
    fullAddress,
  };
};
